export default __webpack_public_path__ + "images/4f21b0c34744e3a573798dd28f34513d-4_tablet_1067x470.webp";